// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Nepal from '../_raw/flag/icon_flag_nepal.png';

export default () => <img src={Nepal} alt="Nepal" />;
